<template>
  

  <div my-5>

    <router-link to="/myforms">
      <v-btn fab dark small color="primary">
        <v-icon dark>keyboard_backspace</v-icon>
      </v-btn>
    </router-link>
    
    <h1 class="text-xs-center">{{ title }}</h1>
    <h2 class="text-xs-center">Report</h2>

    <v-tabs v-model="activeTab" fixed-tabs>

      <v-tab key="groupedResult" ripple>
        Summary
      </v-tab>
      <v-tab key="entries" ripple>
        Entries
      </v-tab>

      <v-tab-item key="groupedResult">

        <v-container>

          <h1 v-if="noData" class="text-xs-center">No Data available</h1>

          <v-layout row wrap>

            <v-flex xs12 sm12 md6 pa-3 v-for="result in finalGroup" :key="result.qid">
              <v-card>
                <v-card-title>
                  <h4>{{ result.question_text }}</h4>
                </v-card-title>

                <v-divider></v-divider>

                  <v-layout row pa-3 ma-3>
                    <v-flex xs12>

                      <div v-if="result.type === 'textbox'">
                        <ul>
                          <li v-for="count, ans in result.result">
                            {{ ans }}
                          </li>
                        </ul>
                      </div>
                      <div v-else-if="result.type === 'photobox'">

                        <v-card flat tile class="d-flex" xs4>
                          <v-img
                            v-for="count, ans in result.result"
                            :src="`https://firebasestorage.googleapis.com/v0/b/turingform.appspot.com/o/${ans}?alt=media`"
                            :lazy-src="`https://firebasestorage.googleapis.com/v0/b/turingform.appspot.com/o/${ans}?alt=media`"
                            width="150"
                            height="150"
                            contain
                          ></v-img>
                        </v-card>
                      </div>
                      <div v-else>
                        <BarChart :answers="result.result"></BarChart>  
                      </div>
                      
                    </v-flex>
                  </v-layout>
                      
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

      </v-tab-item>

      <v-tab-item key="entries" class="px-3">

        <v-layout class="justify-end">
          <v-btn @click="exportCSV" flat class="ma-4" color="info">Download</v-btn>
        </v-layout>

        <v-data-table
          :headers="headers"
          :items="groupedByAnswerId"
          class="elevation-1"
          :rows-per-page-items="[50,100,200]"
        >
          <template v-slot:items="props">
            <td class="text-xs-right" v-for="obj in props.item.data">{{ prettifyAnswer(obj.answer) || "-"}}</td>
          </template>
        </v-data-table>

      </v-tab-item>
    </v-tabs>

    <v-dialog
      v-model="showSyncDialog"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
// @ is an alias to /src
import BarChart from '@/components/BarChart.vue'

export default {
  name: "Report",
  components: {
    BarChart
  },
  props: {},
  data: () => ({
    activeTab : null,
    db : firebase.firestore(),
    questions : [],
    answers : [],
    headers: [],
    groupedByQid: {},
    finalGroup : [],
    groupedByAnswerId : [],
    title : '',
    modifiedAt : '',
    noData: false,
    showSyncDialog: true
  }),
  computed: {
    formId(){
      return this.$route.params.formId;
    }
  },
  created(){
    firebase.auth()
    .onAuthStateChanged((user)=> {
      if (user) {
        // User is signed in.
        this.userObj = user;
        // console.log(user.uid)
        this.fetch();
      } else {
        this.userObj = null;
      }
    });


  },
  mounted() {},
  methods: {

    fetch() {

      this.db.collection('answers')
      .doc(this.formId)
      .collection('answers')
      .get()
      .then((snapshots)=>{

        /* Organize all answers into flatter rows */
        snapshots.forEach((doc)=>{
          
          // const createdAt = doc.data().createdAt;

          this.groupedByAnswerId.push(doc.data());
          this._.each(doc.data().data, (data)=>{
            // console.log(data.qid, data.type, data.answer)
            var copy = this._.cloneDeep(data);
            this.answers.push(copy);
          });

        });

        /* Get all the questions and organize them into headers */
        if (snapshots.docs.length === 0) {
          this.noData = true;
          this.showSyncDialog = false;
          return;
        }

        this.title = snapshots.docs[0].data().title;
        this.modifiedAt = snapshots.docs[0].data().updatedAt;


        _.map(snapshots.docs[0].data().data, (item)=>{

          this.questions.push(item.text);

          this.headers.push({
            text: item.text,
            align: 'left',
            sortable: true,
            value: item.qid
          });

        });
        
        
        /* Aggregate all answers */

        // Group by QID. aka, by questions
        this.groupedByQid = this._.groupBy(this.answers, 'qid');

        // Get the result from each question.
        this._.each(this.groupedByQid, (o)=>{

          var ret = {
              'qid' : o[0].qid,
              'question_text' : o[0].text,
              'type' : o[0].type,
              'result': null
            };

          if (o[0].type === this.formTypes.checkbox){
            // For checkbox questions
            // Counting needs to be done in a custom way
            var checkboxAnswers = [];
            _.map(o, (ans)=>{
              checkboxAnswers = checkboxAnswers.concat(ans.answer);
            });  
            
            checkboxAnswers = _.map(checkboxAnswers, (ans)=>{
              if (ans === undefined) return "No Answer";
              if (ans === null) return "No Answer";
              return ans;
            });

            ret.result = _.countBy(checkboxAnswers);
          } else {

            _.map(o, (ans)=>{
              ans.answer = ans.answer === undefined ? "No Answer" : ans.answer;
            });

            ret.result = this._.countBy(o, 'answer');
          }

          this.finalGroup.push(ret);
        });

        this.showSyncDialog = false;


      });

    },

    prettifyAnswer(answer) {

      if (Array.isArray(answer)){
        return answer.join(",");
      }
      return answer;
    },

    exportCSV() {

      const delimiter = ",";

      var exportString = "";
      _.map(this.headers, (header)=>{
        exportString += header.text + delimiter;
      });
      exportString = "timestamp," + exportString.substr(0, exportString.length - 1) + "\n";

      _.each(this.groupedByAnswerId, (g)=>{
        const createdAt = g.createdAt;
        var line = createdAt + ",";
        _.each(g.data, (answer)=>{
          if (answer.answer) {
            var ans = answer.answer;
            // Enclose with quotes if the answer contains comma. Otherwise, CSV will break.
            if (Array.isArray(answer.answer)) {
              ans = "\"" + ans + "\"";
            }
            line += ans + delimiter;
          } else {
            line += delimiter;
          }
        });
        line = line.substr(0, line.length - 1);
        exportString += line  + "\n";
      });

      const filename = "TuringForm.com " + this.title + " "+ new Date().toDateString() + ".csv";
      const text = exportString;

      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }
  }
};
</script>

<style scoped>

</style>